import withNavigate from "../../../routes/withNavigate.jsx";
import UsersContainer from "./UsersContainer.jsx";
import UsersStore from "./UsersStore.js";

export default UsersStore(withNavigate(UsersContainer));